export default __webpack_public_path__ + "static/media/aggimage_8937.bc367429.jpg";